import { initialisePaymentService } from "@src/PaymentService";
import { getAwsAssets } from "@src/utils";
import { Image } from "@src/components/Image";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../UIElements/Modal";
import {
  setPaymentMethodsAction,
  setSelectedPaymentMethodAction,
  togglePaymentMethodsModalAction,
  toggleMultiPaymentMethodModalAction
} from "../../store/actions";
import ImageSample from "./wallet.svg";

function PaymentMethods() {
  const dispatch = useDispatch();

  const methods = [
    {
      imageUrl: ImageSample,
      text: "Net Banking",
      methodCode: "wallet",
      methodName: "wallet",
      gatewayCode: "rzp",
    },
    {
      imageUrl: ImageSample,
      text: "Net Banking",
      methodCode: "netbanking",
      methodName: "netbanking",
      gatewayCode: "rzp",
    },
    {
      imageUrl: ImageSample,
      text: "Net Banking",
      methodCode: "upi",
      methodName: "upi",
      gatewayCode: "rzp",
    },
    {
      imageUrl: ImageSample,
      text: "Net Banking",
      methodCode: "netbanking",
      methodName: "netbanking",
      gatewayCode: "rzp",
    },
  ];

  const paymentMethods = useSelector(
    (state) => state?.bottomSheetReducer?.paymentMethods
  );

  return (
    <Modal
      handleClose={() => {
        dispatch(togglePaymentMethodsModalAction(false));
        dispatch(setPaymentMethodsAction(null));
        dispatch(setSelectedPaymentMethodAction(null));
      }}
      header="Select Payment Method"
    >
      <div className="PaymentMethods">
        <div className="PaymentMethods__Note">
          Please choose from one of the following payment methods
        </div>
        <div className="PaymentMethods__List">
          {paymentMethods?.map?.((item, i) => (
            <div
              className="PaymentMethods__List--Item"
              onClick={() => {
                dispatch(setSelectedPaymentMethodAction(item));
                initialisePaymentService();
              }}
              key={i}
            >
              <div className="PaymentMethods__List--Item--Left">
                <Image src={item?.imageUrl} width={24} height={24} alt="Icon" />
                {item?.methodName}
              </div>
              <div className="PaymentMethods__List--Item--Right">
                <Image
                  src={getAwsAssets("leftAngleIcon.svg", "content")}
                  alt="leftAngleIcon"
                  width={5}
                  height={10}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}

export default PaymentMethods;
